import React, { useState } from 'react';
import axios from 'axios';
import api from '../../../../../services/api';
import { resizeImage, validateImageFile } from '../../../utils/imageUtils';

const ImageUpload = ({ taskForm, setTaskForm, isSubmitting }) => {
  const [uploadProgress, setUploadProgress] = useState({});
  const [isUploading, setIsUploading] = useState(false);

  const handleImageUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    setUploadProgress({});
    setIsUploading(true);

    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        
        // Validate file
        const validation = validateImageFile(file);
        if (!validation.valid) {
          alert(`File ${file.name}: ${validation.error}`);
          continue;
        }

        const resizedFile = await resizeImage(file);

        // 1. Get presigned URL
        const response = await api.get('/api/upload/presigned-url', {
          params: { fileType: resizedFile.type }
        });
        const { uploadUrl, fileUrl } = response.data;

        // 2. Upload to S3
        await axios.put(uploadUrl, resizedFile, {
          headers: { 'Content-Type': resizedFile.type },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(prev => ({
              ...prev,
              [i]: percentCompleted
            }));
          }
        });

        // 3. Store fileUrl in form state
        setTaskForm(prev => ({
          ...prev,
          images: [...prev.images, fileUrl]
        }));
      }
      setUploadProgress({});
    } catch (err) {
      console.error('Upload error:', err);
      alert('Failed to upload images');
    } finally {
      setIsUploading(false);
    }
  };

  const removeImage = (index) => {
    setTaskForm(prev => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index)
    }));
  };

  return (
    <div className="form-group">
      <label>Images</label>
      
      {/* File Input */}
      <div className="image-upload">
        <input
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageUpload}
          className="form-control"
          disabled={isSubmitting || isUploading}
        />
        
        {/* Upload Progress */}
        {Object.keys(uploadProgress).length > 0 && (
          <div className="upload-progress">
            {Object.entries(uploadProgress).map(([index, progress]) => (
              <div key={index} className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${progress}%` }}
                />
                <span className="progress-text">{progress}%</span>
              </div>
            ))}
          </div>
        )}
      </div>
      
      {/* Image Preview Grid */}
      <div className="image-preview-grid">
        {taskForm.images.map((image, index) => (
          <div key={index} className="image-preview">
            <img src={image} alt={`Preview ${index + 1}`} />
            <button 
              className="remove-image"
              onClick={() => removeImage(index)}
              disabled={isSubmitting || isUploading}
              aria-label={`Remove image ${index + 1}`}
              title="Remove image"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      {/* Upload Status */}
      {isUploading && (
        <div className="upload-status">
          <span>Uploading images...</span>
        </div>
      )}
    </div>
  );
};

export default ImageUpload; 